/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContactInfo } from './ContactInfo';
import {
    ContactInfoFromJSON,
    ContactInfoFromJSONTyped,
    ContactInfoToJSON,
} from './ContactInfo';

/**
 * 
 * @export
 * @interface ClientInfo
 */
export interface ClientInfo {
    /**
     * 
     * @type {string}
     * @memberof ClientInfo
     */
    name: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientInfo
     */
    referenceNumbers: Array<string> | null;
    /**
     * 
     * @type {ContactInfo}
     * @memberof ClientInfo
     */
    contactInformation: ContactInfo | null;
}

/**
 * Check if a given object implements the ClientInfo interface.
 */
export function instanceOfClientInfo(value: object): value is ClientInfo {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('referenceNumbers' in value) || value['referenceNumbers'] === undefined) return false;
    if (!('contactInformation' in value) || value['contactInformation'] === undefined) return false;
    return true;
}

export function ClientInfoFromJSON(json: any): ClientInfo {
    return ClientInfoFromJSONTyped(json, false);
}

export function ClientInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'referenceNumbers': json['referenceNumbers'],
        'contactInformation': ContactInfoFromJSON(json['contactInformation']),
    };
}

export function ClientInfoToJSON(value?: ClientInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'referenceNumbers': value['referenceNumbers'],
        'contactInformation': ContactInfoToJSON(value['contactInformation']),
    };
}

